import config from "../../config";
import {Avatar} from '../../catalyst/avatar'
import  SpotifyIcon  from "../../assets/Spotify_Icon_RGB_Green.png";
import  YouTubeIcon  from "../../assets/youtube_social_icon_red.png";

import  YouTubeMusicIcon  from "../../assets/youtube-music-icon.png";

import  AppleMusicIcon  from "../../assets/appleMusic.svg";

import HomeBanner from "../../assets/home-banner.jpg"
import TransferBanner from "../../assets/transfer-playlist.png"
import SyncBanner from "../../assets/sync-playlists.png"

import NavBar from "../navbar";
import Footer from "../footer";

import { Link } from "react-router-dom";
import 'flowbite';
import { Helmet } from "react-helmet";



export default function HomePage()
{
    return (

        <>

  {/* {Navbar} */}
  <NavBar selected={"home"}></NavBar>

  {/* Start block */}
  <section className="bg-white dark:bg-zinc-950">
    <div className="grid max-w-screen-xl px-4 pt-20 pb-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12 lg:pt-28">
      <div className="mr-auto place-self-center lg:col-span-7">
        <h1 className="max-w-2xl mb-4 text-4xl font-extrabold leading-none tracking-tight md:text-5xl xl:text-6xl dark:text-white">
          Transfer playlists <br />
          in 3 clicks
        </h1>

        <p className="font-semibold mt-3 mb-6 dark:text-white">Keep your music. Change your platform. Stay in sync.</p>
        
        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
        Transfer music collection across Spotify, Apple Music and YouTube for free. Sync music across paltforms 
        </p>

        

        <div className="space-y-4 sm:flex sm:space-y-0 sm:space-x-4">
          <Link
            to="/login"
            className="inline-flex items-center justify-center w-full px-5 py-3 text-sm font-medium text-center text-gray-900 border border-gray-200 rounded-lg sm:w-auto hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800"
          >
            Start for free
          </Link>

        </div>
      </div>
      <div className="hidden lg:mt-0 lg:col-span-5 lg:flex">
        <img src={HomeBanner} alt="Transfer playlists" />
      </div>
    </div>
  </section>
  {/* End block */}


  {/* Start block */}
  <section className="bg-white dark:bg-zinc-950">
    <div className="max-w-screen-xl px-4 pb-8 mx-auto lg:pb-16">
      <div className="grid grid-cols-2 gap-8 text-gray-500 sm:gap-12 sm:grid-cols-3 lg:grid-cols-4 dark:text-gray-400">
        <a href="#" className="flex items-center lg:justify-center">

          <img src={SpotifyIcon} className="rounded-lg  p-8" alt="transfer spotify playlists" />

        </a>
        <a href="#" className="flex items-center lg:justify-center">

        <img src={AppleMusicIcon} className="rounded-lg p-8" alt="transfer apple music playlists" />

        </a>
        <a href="#" className="flex items-center lg:justify-center">

        <img src={YouTubeIcon} className="rounded-lg p-8" alt="transfer youtube playlists" />

        </a>
        <a href="#" className="flex items-center lg:justify-center">

        <img src={YouTubeMusicIcon} className="rounded-lg p-8" alt="transfer youtube music playlists" />

        </a>

      </div>
    </div>
  </section>
  {/* End block */}

  {/* Start block */}
  <section className="bg-gray-50 dark:bg-zinc-800">
    <div className="max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 lg:py-24 lg:px-6">
      {/* Row */}
      <div className="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
        <div className="text-gray-500 sm:text-lg dark:text-gray-400">
          <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            Transfer and manage your playlists
          </h2>
          <p className="mb-8 font-light lg:text-xl">
            Our features focusing on making your transfer accurate, seamless and efficient.
          </p>
          {/* List */}
          <ul
            role="list"
            className="pt-8 space-y-5 border-t border-gray-200 my-7 dark:border-gray-700"
          >
            <li className="flex space-x-3">
              {/* Icon */}
              <svg
                className="flex-shrink-0 w-5 h-5 text-purple-500 dark:text-purple-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">
                Search and add missing tracks
              </span>
            </li>
            <li className="flex space-x-3">
              {/* Icon */}
              <svg
                className="flex-shrink-0 w-5 h-5 text-purple-500 dark:text-purple-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">
                  Validate matching tracks before transfer
              </span>
            </li>
            <li className="flex space-x-3">
              {/* Icon */}
              <svg
                className="flex-shrink-0 w-5 h-5 text-purple-500 dark:text-purple-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">
                Edit your playlists
              </span>
            </li>
          </ul>
          <p className="mb-8 font-light lg:text-xl">
            Transfer your playlists to new service and manage them in one place 
          </p>
          <div>
                      <a href={config.trasferFeaturePage} class="inline-flex items-center text-base font-medium text-purple-600 hover:text-purple-800 dark:text-purple-500 dark:hover:text-purple-700">
                        Explore transfer feature
                        <svg class="w-5 h-5 ml-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                      </a>
          </div>
        </div>
        <img
          className="hidden w-full mb-4 rounded-lg lg:mb-0 lg:flex"
          src={TransferBanner}
          alt="Transfer Playlists, albums and favourite songs"
        />
      </div>
      {/* Row */}
      <div className="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
        <img
          className="hidden w-full mb-4 rounded-lg lg:mb-0 lg:flex"
          src={SyncBanner}
          alt="Sync Playlists and favourite songs"
        />
        <div className="text-gray-500 sm:text-lg dark:text-gray-400">
          <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            Keep your playlists in sync across services
          </h2>
          <p className="mb-8 font-light lg:text-xl">
            Do you want the new playlist to be in sync with old playlist? With Sync, your playlists stay updated across all your connected streaming platforms — without lifting a finger
          </p>
          {/* List */}
          <ul
            role="list"
            className="pt-8 space-y-5 border-t border-gray-200 my-7 dark:border-gray-700"
          >
            <li className="flex space-x-3">
              {/* Icon */}
              <svg
                className="flex-shrink-0 w-5 h-5 text-purple-500 dark:text-purple-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">
              Daily sync for changes
              </span>
            </li>
            <li className="flex space-x-3">
              {/* Icon */}
              <svg
                className="flex-shrink-0 w-5 h-5 text-purple-500 dark:text-purple-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">
                View and edit sync changes
              </span>
            </li>
            <li className="flex space-x-3">
              {/* Icon */}
              <svg
                className="flex-shrink-0 w-5 h-5 text-purple-500 dark:text-purple-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">
              See a full history of sync actions
              </span>
            </li>

          </ul>
          <p className="font-light lg:text-xl">
          Whether you add a new song, or delete a song, MusicPorter ensures everything stays consistent..
          </p>          
          <div>
                      <a href={config.syncFeaturePage} class="inline-flex items-center text-base font-medium text-purple-600 hover:text-purple-800 dark:text-purple-500 dark:hover:text-purple-700">
                        Explore sync feature
                        <svg class="w-5 h-5 ml-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                      </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* End block */}
  {/* Start block */}




  <section className="bg-white dark:bg-zinc-950">
    <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-24 lg:px-6 ">
      <h2 className="mb-6 text-3xl font-extrabold tracking-tight text-center text-gray-900 lg:mb-8 lg:text-3xl dark:text-white">
        Frequently asked questions
      </h2>
      <div className="max-w-screen-md mx-auto">
        <div
          id="accordion-flush"
          data-accordion="collapse"
          data-active-classes="bg-white dark:bg-zinc-950 text-gray-900 dark:text-white"
          data-inactive-classes="text-gray-500 dark:text-gray-400"
        >
          <h3 id="accordion-flush-heading-1">
            <button
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-900 bg-white border-b border-gray-200 dark:border-gray-700 dark:bg-zinc-950 dark:text-white"
              data-accordion-target="#accordion-flush-body-1"
              aria-expanded="true"
              aria-controls="accordion-flush-body-1"
            >
              <span>How it works?</span>
              <svg
                data-accordion-icon=""
                className="w-6 h-6 rotate-180 shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </h3>
          <div
            id="accordion-flush-body-1"
            className=""
            aria-labelledby="accordion-flush-heading-1"
          >
            <div className="py-5 border-b border-gray-200 dark:border-gray-700">
              <p className="mb-2 text-gray-500 dark:text-gray-400">
              When you transfer or sync your music, MusicPorter searches for matching songs, playlists, albums, and artists using metadata like titles and artist names. We do our best to find exact or close equivalents on the destination platform. However, if a track isn’t available in the target service’s catalog, it won’t be included in the transfer or sync. Use our powerful tools to edit playlists, add missing songs or validate trasferred songs.
              </p>
              <p className="text-gray-500 dark:text-gray-400">
                Check out this guide to learn {" "}
                <a
                  href="/transfer-playlists-and-songs"
                  className="text-purple-600 dark:text-purple-500 underline"
                >
                  how to transfer playlists and songs
                </a>{" "}
                from one service to another.
              </p>
            </div>
          </div>
          <h3 id="accordion-flush-heading-2">
            <button
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400"
              data-accordion-target="#accordion-flush-body-2"
              aria-expanded="false"
              aria-controls="accordion-flush-body-2"
            >
              <span>How much does it cost?</span>
              <svg
                data-accordion-icon=""
                className="w-6 h-6 shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </h3>
          <div
            id="accordion-flush-body-2"
            className="hidden"
            aria-labelledby="accordion-flush-heading-2"
          >
            <div className="py-5 border-b border-gray-200 dark:border-gray-700">
              <p className="mb-2 text-gray-500 dark:text-gray-400">
                We are running beta promotion and currently offering free transfer & sync for all our users.
              </p>

            </div>
          </div>
          <h3 id="accordion-flush-heading-3">
            <button
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400"
              data-accordion-target="#accordion-flush-body-3"
              aria-expanded="false"
              aria-controls="accordion-flush-body-3"
            >
              <span>
                How safe is MusicPorter?
              </span>
              <svg
                data-accordion-icon=""
                className="w-6 h-6 shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </h3>
          <div
            id="accordion-flush-body-3"
            className="hidden"
            aria-labelledby="accordion-flush-heading-3"
          >
            <div className="py-5 border-b border-gray-200 dark:border-gray-700">
              <p className="mb-2 text-gray-500 dark:text-gray-400">
                We follow .
              </p>
              <p className="mb-2 text-gray-500 dark:text-gray-400">
              At MusicPorter, your privacy and security are our top priorities. We follow industry best practices to protect your data and respect the privacy policies of the streaming services we integrate with.
              </p>
              <p className="mb-2 text-gray-500 dark:text-gray-400">
                Learn more about {" "}
                  <a
                    href="/privacy-and-terms"
                    className="text-purple-600 dark:text-purple-500 hover:underline"
                  >
                    privacy policy.
                  </a>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
  {/* End block */}
  {/* Start block */}
  <section className="bg-gray-50 dark:bg-zinc-800">
    <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-16 lg:px-6">
      <div className="max-w-screen-sm mx-auto text-center">
        <h2 className="mb-4 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white">
          Start your transfer for free
        </h2>
        <p className="mb-6 font-light text-gray-500 dark:text-gray-400 md:text-lg">
          
        </p>
        <a
          href={config.signupPath}
          className="text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 focus:outline-none dark:focus:ring-purple-800"
        >
          Sign up
        </a>
      </div>
    </div>
  </section>
  {/* End block */}

  <Footer></Footer>
</>


    )
}